import { View } from 'react-native';
import styled from 'styled-components/native';

export const LeftContentContainer = styled(View)`
    margin-left: 24px;
`;
